// #region Imports
import { quickAddToCart } from '@js/helpers';

// #endregion

export function onQuickAddClick(event) {
  event.preventDefault();

  const btn = event.target;
  const productVariantId = btn.getAttribute('data-variant-id');

  btn.classList.add('btn--loading');
  quickAddToCart(productVariantId)
    .then((data) => {
      document.dispatchEvent(
        new CustomEvent('ajaxProduct:added', {
          detail: {
            product: data,
            addToCartBtn: btn,
          },
        })
      );
    })
    .finally(() => setTimeout(() => btn.classList.remove('btn--loading'), 1000));
}
